import { render, staticRenderFns } from "./MReviewSKPD.vue?vue&type=template&id=e387376e&scoped=true&lang=html&"
import script from "./MReviewSKPD.vue?vue&type=script&lang=js&"
export * from "./MReviewSKPD.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e387376e",
  null
  
)

export default component.exports